import React from 'react';

/** Whether a click carried a modifier key, i.e. the user asked the browser for something other than
 * a plain activation — a new tab, a new window, a download, an extended selection.
 *
 * Both linked cells intercept a plain left-click to do something in place (open the task modal, route
 * in-app so the leave guard can catch it) and must leave a modified click alone, because the anchor's
 * real `href` is what makes cmd/ctrl-click open a working tab instead of a dead one. Getting this
 * check wrong in only one of them is how the two cells would start behaving differently, so they read
 * it from here rather than each spelling it out. */
export function isModifiedClick(event: React.MouseEvent): boolean {
	return event.metaKey || event.ctrlKey || event.shiftKey || event.altKey;
}
